import styled from "styled-components";
import { MainBox } from "../../../theme/global.styles";

export const CMAuctionStatus = styled(MainBox)(props => ({
    backgroundColor: '#fff',

    '&.auction-progress': {
        backgroundImage: 'unset',
        paddingBottom: 0,
    },

    '&.auction-upcoming': {
        paddingTop: 0,
    },

    '&.auction-scheduled': {
        backgroundColor:  props.theme.palette.gray["500"],
    }
}));
